// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z6Sj","field":"styles_field__2THjm","fieldCol":"styles_fieldCol__j1ZE5","diffCol":"styles_diffCol__2hdgs","diff":"styles_diff__1J6Xd"};